
import { Options, Vue }    from 'vue-class-component';
import MultiLevelSelect from './multi-level-select.vue'
import { CheckOutlined } from '@ant-design/icons-vue';
import { chain, keyBy, mapValues } from 'lodash'

@Options({
  components: {
    MultiLevelSelect
  },
  props: {
    tiles: {type: Array},
    items: {type: Array},
    errors: {type: Object}
  },
  data() {
    return {
      items: []
    }
  },
  watch: {
    tiles: {
      handler: function (newVal) {
        this.$emit('getTiles', newVal);
      },
      deep: true
    },
    '$store.state.meshCreated'() {
      if ((this.tiles || []).length === 0) {
        this.openDrawer(0)
      }
    }
  },
  mounted(){
    let storeErrors = this.$store.state.errors || {};
    if((this.tiles || []).length === 0 ){
      storeErrors.tiles = 'Prosimo izberite tlakovec.'
    } else {
      storeErrors.tiles = null
    }
    this.$store.commit('setErrors',storeErrors)

    const productRes = this.$store.state.responseTiles

    let lines = [];

    productRes.forEach(function (x) {return lines.push(x.propertyAttributes.find(y=> y.key === 'linija')?.value)})

    this.items = productRes.map(x=> ({
      id: x._id,
      key: x.key,
      title: x.name,
      attributes: chain(x.propertyAttributes).keyBy('key').mapValues('value').value(),
      price: x.priceUnit ? `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} € / ${x.priceUnit}` : `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} €`,
      priceWithoutDiscount: x.priceUnit ? `${x.estimatedPrice.retailPrice.toFixed(2)} € / ${x.priceUnit}` : `${x.estimatedPrice.retailPrice.toFixed(2)} €`,
      discount: x.estimatedPrice.retailPriceDiscount?.value > 0 ? true : false,
      thumbnail: x.metadata.thumbnail,
      tileRender: x.media?.gallery?.length > 0 && x.media?.gallery[0].src,
      active: false,
      scale: null,
      rotation: null,
      offset: null
    }));

    if(this.$store.state.previewImageUrl?.includes('house-presets') && (this.tiles || []).length === 0){
      this.openDrawer(0)
    }

  },
  methods: {
    openDrawer(i) {
      this.$refs.multiLevel.index = i;
      this.$refs.multiLevel.visibleLines = true;
    },
    removeTile(i) {
      this.tiles.splice(i,1)
    },
    select(i) {
      for(let x = 0; x < this.tiles.length; x++){
        if(x === i){
          this.tiles[x].active = true;
        } else {
          this.tiles[x].active = false;
        }
      }
    }
  }
})

export default class PaverPicker extends Vue {
}

